import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		name: 'What goes here? Session shite, maybe?'
	}
});

export default app;